import React, { CSSProperties } from 'react';

interface DocumentProps {
  fill?: string;
  secondaryfill?: string;
  width?: string;
  height?: string;
  style?: CSSProperties;
  className?: string;
}

const Document: React.FC<DocumentProps> = ({ fill = 'currentColor', secondaryfill, width = '100%', height = '100%', style, className }) => {
  return (
    <svg className={className} height={height} width={width} viewBox="0 0 1060 1060" xmlns="http://www.w3.org/2000/svg" style={style}>
      <g fill={fill}>
        <defs />
        <path className="cls-1" d="M782.17 915H277.83c-20.2 0-36.58-16.38-36.58-36.58V181.58c0-20.2 16.38-36.58 36.58-36.58h277.35c145.57 0 263.57 118 263.57 263.57v469.85c0 20.2-16.38 36.58-36.58 36.58z" fill="none" stroke={fill} strokeLinecap="round" strokeLinejoin="round" strokeWidth="50px" />
        <path className="cls-1" d="M555.18 433.75h263.57v-25.18C818.75 263 700.75 145 555.18 145v288.75z" fill="none" stroke={fill} strokeLinecap="round" strokeLinejoin="round" strokeWidth="50px" />
      </g>
    </svg>
  );
};

export default Document;
